export default "__VITE_ASSET__NHOTTw3a__"